import { HttpErrorResponse } from '@angular/common/http';
import { HandoverChain, HandoverStage } from '../../models/handover-chain.model';
import { UebergabeStufe } from '../../models/details-historie.model';

const FEHLER_KEY = 'common.detailsHistorie.uebergabe.fehler.';

const FEHLER_JE_CODE: Record<string, string> = {
  USER_ALREADY_HANDED_OFF: 'bereitsWeitergegeben',
  SELF_HANDOVER_NOT_ALLOWED: 'anSichSelbst',
  HANDOVER_CHAIN_CLOSED: 'abgeschlossen',
  HANDOVER_ALREADY_SKIPPED: 'geaendert',
  HANDOVER_STAGE_NOT_ACTIVE: 'geaendert',
};

function sortiert(chain: HandoverChain | null): HandoverStage[] {
  return [...(chain?.stages ?? [])].sort((a, b) => a.orderIndex - b.orderIndex);
}

// Stufe 1 hat niemand übergeben, sie zeigt im Panel „erstellt“ statt „von …“.
export function toUebergabeStufen(chain: HandoverChain | null): UebergabeStufe[] {
  return sortiert(chain).map((stage, index) => ({
    stageId: stage.id,
    userId: stage.userId,
    displayName: stage.displayName ?? '',
    message: stage.message ?? null,
    handedOverByName: index === 0 ? null : (stage.handedOverByName ?? null),
    handedOffAt: stage.handedOffAt,
    createdAt: stage.createdAt,
    skipped: !!stage.skipped,
  }));
}

export function aktiveStufe(chain: HandoverChain | null): HandoverStage | null {
  return (
    sortiert(chain)
      .filter((stage) => stage.handedOffAt == null && !stage.skipped)
      .at(-1) ?? null
  );
}

// Nach dem Überspringen hat die aktive Person den Testfall erst seit dem Überspringen wieder.
export function aktivSeit(chain: HandoverChain | null): string | null {
  const stufen = sortiert(chain);
  const aktiv = aktiveStufe(chain);
  if (!aktiv) return null;
  const danach = stufen.slice(stufen.indexOf(aktiv) + 1);
  if (danach.length === 0 || danach.some((stage) => !stage.skipped)) return null;
  return danach.at(-1)?.skippedAt ?? null;
}

export function uebergabeFehlerKey(err: HttpErrorResponse): string {
  const code: unknown = err?.error?.code;
  const schluessel = typeof code === 'string' ? FEHLER_JE_CODE[code] : undefined;
  return FEHLER_KEY + (schluessel ?? 'allgemein');
}

export function uebergebenGesperrt(chain: HandoverChain | null, ownerUserId: string | null): boolean {
  if (!ownerUserId) return false;
  return (chain?.stages ?? []).some((stage) => stage.userId === ownerUserId && stage.handedOffAt != null);
}
